import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ResponseFilterInfringements } from '../../../../../interfaces/reports/reports';
import { OrderPipe } from 'ngx-order-pipe';

@Component({
  selector: 'app-report-table-infractions',
  templateUrl: './report-table-infractions.component.html',
  styleUrls: ['./report-table-infractions.component.css']
})
export class ReportTableInfractionsComponent implements OnInit {

  @Input() detailInfractionsByFilter: ResponseFilterInfringements[] = []
  @Output() exportToExcel = new EventEmitter<any>();

  constructor(private orderPipe: OrderPipe) {
    this.detailInfractionsByFilter = this.detailInfractionsByFilter.slice();
    this.collectionToOrder = this.orderPipe.transform(this.detailInfractionsByFilter, 'detailInfractionsByFilter.id');
  }

  ngOnInit(): void {
  }

  //  ------> sorting activities  <-------
  orderActivities: string = ''
  reverse: boolean = false;
  collectionToOrder: Partial<ResponseFilterInfringements[]>;

  order: string = ''
  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }
  getSortingStatusImage(orderStatus: 1 | 2 | 3, arrow: 'UP' | 'DOWN') {
    if (arrow === 'UP') {
      if (orderStatus === 2) {
        return 'assets/img/arrow_r_g.png';
      }
      return 'assets/img/arrow_b_g.png';
    }

    if (orderStatus === 3) {
      return 'assets/img/arrow_r_g.png';
    }
    return 'assets/img/arrow_b_g.png';
  }

  //  ------> paginate activities  <-------

  public config: any = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: this.detailInfractionsByFilter.length,
  };

  public maxSize: number = 30;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;
  public labels: any = {
    previousLabel: '<',
    nextLabel: '>',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: 'You\'re on page',
  };

  searchText = '';

  export() {
    this.exportToExcel.emit();
  }
}
